module.exports = __webpack_public_path__ + "img/IMG_4627.601eecda.jpg";